<script lang="ts">
    export let creature;
    $: subHeadline = `Size ${creature.size}`;
    $: if (creature.frightening) subHeadline += " frightening";
    $: if (creature.horrifying) subHeadline += " horrifying";
    $: subHeadline += " " + creature.descriptors.join(" ");
</script>

<div class="creature">
    <div class="headline">
        <span class="name">{creature.name.toUpperCase()}</span>
        <span class="difficulty">DIFFICULTY {creature.difficulty}</span>
    </div>
    <div class="subheadline">
        <span>{subHeadline}</span>
    </div>
    {creature.book} (p. {creature.page})
</div>

<style>
    .creature {
        margin: 2vw;
        font-family: "Athelas";
        text-align: left;
        width: 65vw;
        max-width: 425px;
    }
    .headline {
        display: flex;
        justify-content: space-between;
        color: white;
        background-color: black;
        padding: 8px;
    }
    .name {
        font-size: 1rem;
    }
    .difficulty {
        display: flex;
        font-size: 0.75rem;
    }

    .subheadline {
        color: white;
        background-color: #9c0719;
        font-size: 0.95rem;
        font-style: italic;
        padding: 4px;
        margin-top: 2px;
        padding-left: 8px;
    }
    @media (min-width: 768px) {
        .creature {
            margin: 24px;
            min-width: 425px;
            font-family: "Athelas";
            text-align: left;
        }
        .headline {
            display: flex;
            justify-content: space-between;
            color: white;
            background-color: black;
            padding: 8px;
        }
        .name {
            font-size: 1.25rem;
        }
        .difficulty {
            display: flex;
            font-size: 1rem;
        }

        .subheadline {
            color: white;
            background-color: #9c0719;
            font-size: 1.2rem;
            font-style: italic;
            padding: 4px;
            margin-top: 2px;
            padding-left: 8px;
        }
    }
</style>
